import settings from './settings-store.mjs';
import { reset as resetScroll, addScreen as addScroll, hazards } from './currentweatherscroll.mjs';

let firstRun = true;

// change of enable handler
const changeEnable = (newValue) => {
	let newDisplay;
	if (newValue) {
		// add the text to the scroll
		parseText(settings.get('customText'));
		// show the string box
		newDisplay = 'block';
	} else {
		// set scroll back to original
		resetScroll();
		// hide the string entry
		newDisplay = 'none';
	}
	const stringEntry = document.getElementById('settings-customText-string');
	if (stringEntry) {
		stringEntry.style.display = newDisplay;
	}
};

// parse the text provided
const parseText = (textInput) => {
	// skip updating text on first run
	if (firstRun) return;

	// test validity
	if (textInput === undefined || textInput === '') {
		resetScroll();
	}

	// split the text at pipe characters
	const texts = textInput.split('|');

	// add single text scroll after hazards if present
	resetScroll();
	addScroll(hazards);
	addScroll(
		() => {
			// pick a random string from the available list
			const randInt = Math.floor(Math.random() * texts.length);
			return {
				type: 'scroll',
				text: texts[randInt],
			};
		},
		// keep the existing scroll
		true,
	);
};

// change the text
const changeText = (newValue) => {
	// first pass through won't have custom text enable ready
	if (firstRun) return;

	if (settings.get('customTextEnable')) {
		parseText(newValue);
	}
};

// generate a checkbox control for customTextEnable
const generateEnableCheckbox = () => {
	const label = document.createElement('label');
	label.htmlFor = 'settings-customTextEnable-checkbox';
	label.id = 'settings-customTextEnable-label';
	const checkbox = document.createElement('input');
	checkbox.type = 'checkbox';
	checkbox.value = true;
	checkbox.id = 'settings-customTextEnable-checkbox';
	checkbox.name = 'settings-customTextEnable-checkbox';
	checkbox.checked = settings.get('customTextEnable');
	checkbox.addEventListener('change', (e) => {
		settings.set('customTextEnable', e.target.checked);
	});
	const span = document.createElement('span');
	span.textContent = 'Enable Custom Text';
	label.append(checkbox, span);
	return label;
};

// generate a string input control for customText
const generateTextInput = () => {
	const label = document.createElement('label');
	label.htmlFor = 'settings-customText-string';
	label.id = 'settings-customText-label';
	const textInput = document.createElement('input');
	textInput.type = 'text';
	textInput.value = settings.get('customText');
	textInput.id = 'settings-customText-string';
	textInput.name = 'settings-customText-string';
	textInput.placeholder = 'Text to scroll';
	const setButton = document.createElement('input');
	setButton.type = 'button';
	setButton.value = 'Set';
	setButton.id = 'settings-customText-button';
	setButton.name = 'settings-customText-button';
	setButton.addEventListener('click', () => {
		settings.set('customText', textInput.value);
	});
	label.append(textInput, setButton);
	return label;
};

// register change listeners
settings.on('customTextEnable', changeEnable);
settings.on('customText', changeText);

// initialize the custom text inputs on the page
document.addEventListener('DOMContentLoaded', () => {
	firstRun = false;
	// add the controls to the page if the legacy settings panel exists
	const settingsSection = document.querySelector('#settings');
	if (settingsSection) {
		settingsSection.append(generateEnableCheckbox(), generateTextInput());
	}
	// call change enable with the current value to show/hide the url box
	changeEnable(settings.get('customTextEnable'));
});
